export default {
  Official: 0,
  Advance: 1,
};
